[
  {
    "countryKey": "CZ",
    "responsibleLocationKey": "GLS_CZ_CZ0001"
  },
  {
    "countryKey": "HR",
    "responsibleLocationKey": "GLS_HR_HR0010"
  },
  {
    "countryKey": "HU",
    "responsibleLocationKey": "GLS_HU_HU0010"
  },
  {
    "countryKey": "IT",
    "responsibleLocationKey": "GLS_IT_ITMI05"
  },
  {
    "countryKey": "RO",
    "responsibleLocationKey": "GLS_RO_RO0055"
  },
  {
    "countryKey": "SI",
    "responsibleLocationKey": "GLS_SI_SI1000"
  },
  {
    "countryKey": "SK",
    "responsibleLocationKey": "GLS_SK_SK0098"
  },
  {
    "countryKey": "BG",
    "responsibleLocationKey": "PARTNER_INTERLGBG_BG0010"
  },
  {
    "countryKey": "EE",
    "responsibleLocationKey": "PARTNER_ITELLAEE_EE1TAL"
  },
  {
    "countryKey": "LT",
    "responsibleLocationKey": "PARTNER_ITELLALT_LT1KAU"
  },
  {
    "countryKey": "LV",
    "responsibleLocationKey": "PARTNER_ITELLALV_LV1RIG"
  },
  {
    "countryKey": "MT",
    "responsibleLocationKey": "PARTNER_MTPOST_MT1000"
  },
  {
    "countryKey": "GB",
    "responsibleLocationKey": "PARTNER_PFW_GB0100"
  },
  {
    "countryKey": "SE",
    "responsibleLocationKey": "PARTNER_SCHENKERSE_SESMTR"
  },
  {
    "countryKey": "CH",
    "responsibleLocationKey": "PARTNER_SWISS_CH4002"
  }
]
